import React from 'react';

const QuestGameBody = () => {
  return (
    <div className="absolute h-fit w-full top-0 left-0 z-[10] px-4 py-4">
      <div className="flex justify-between items-center w-full gap-4">
        <div className="flex items-center gap-3 bg-gradient-to-br from-emerald-500/90 to-teal-600/90 backdrop-blur-md rounded-2xl px-5 py-3 shadow-lg border border-white/20 transition-all hover:scale-105 hover:shadow-xl">
          <div className="flex items-center justify-center w-8 h-8 bg-white/20 rounded-full">
            <svg
              className="w-5 h-5 text-yellow-300"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
            </svg>
          </div>
          <div className="flex flex-col">
            <span className="text-[10px] font-medium text-white/70 uppercase tracking-wider">
              Score
            </span>
            <span
              className="text-2xl font-bold text-white leading-none"
              id="score"
            >
              0
            </span>
          </div>
        </div>

        <div className="flex items-center gap-3 bg-gradient-to-br from-purple-500/90 to-pink-600/90 backdrop-blur-md rounded-2xl px-5 py-3 shadow-lg border border-white/20 transition-all hover:scale-105 hover:shadow-xl">
          <div className="flex items-center justify-center w-8 h-8 bg-white/20 rounded-full">
            <svg
              className="w-5 h-5 text-white"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2.5}
                d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
          </div>
          <div className="flex flex-col">
            <span className="text-[10px] font-medium text-white/70 uppercase tracking-wider">
              Time
            </span>
            <span
              className="text-2xl font-bold text-white leading-none"
              id="timer"
            >
              0
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuestGameBody;
